<template>
  <div class="security">
    <div class="security__header">
      <div class="security__header__title">Security</div>
      <img @click="$router.push('/')" class="security__header__close" src="@/assets/images/svg/close.svg" alt="close">
    </div>
    <form @submit.prevent class="security__form">
      <div class="security__form__title">
        <div class="security__form__title__label">Security</div>
        <BaseButton label="save" type="submit" @click="changePasswordHandler" />
      </div>
      <div class="security__form__list">
        <div class="security__form__list__item">
          <div class="security__form__list__item__title">Change password</div>
          <BaseInput v-model="password.old_password"
                     type="password"
                     placeholder="Current password"
                     required
          />
        </div>
        <div class="security__form__list__item">
          <BaseInput v-model="password.new_password"
                     type="password"
                     placeholder="New password"
                     required
          />
        </div>
        <div class="security__form__list__item">
          <BaseInput v-model="password.new_password_confirm"
                     type="password"
                     placeholder="Confirm New password"
                     required
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import { changePassword } from "@/services/auth";
import BaseButton from '../ui/atoms/BaseButton.vue'
import BaseInput from '../ui/atoms/BaseInput.vue'

export default {
  components: { BaseInput, BaseButton },
  name: "ProfileSecurity",
  data() {
    return {
      password: {
        old_password: '',
        new_password: '',
        new_password_confirm: ''
      },
    }
  },
  methods: {
    ...mapActions({
      setIsLoading: 'setIsLoading',
      setSnackbarError: 'setSnackbarError',
      setSnackbarSuccess: 'setSnackbarSuccess'
    }),
    changePasswordHandler() {
      this.setIsLoading(true)
      changePassword(this.password)
        .then(() => {
          this.setSnackbarSuccess('Password updated successfully')
          this.$router.push('/profile')
        })
        .catch(({ message }) => this.setSnackbarError(message))
        .finally(() => this.setIsLoading(false))
    }
  }
}
</script>

<style lang="scss" scoped>
.security {

  &__header {
    display: flex;
    justify-content: space-between;
    padding: 1.25rem;
    border-bottom: 0.0625rem solid;

    &__title {
      font-style: normal;
      font-weight: 600;
      font-size: 0.85rem;
    }

    &__close {
      cursor: pointer;
    }

  }

  &__form {
    padding: 0.625rem 2rem;

    &__title {
      display: flex;
      justify-content: space-between;

      &__label {
        font-style: normal;
        font-weight: 600;
        font-size: 1.1rem;
        padding: 2.5rem 0;
        color: #272829;
      }

      button {
        height: 2.5rem;
        line-height: 2.3rem;
        width: 5rem;
      }

    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 2rem;
      margin: 3.125rem auto;
      max-width: 34.4rem;

      &__item {

        &__title {
          text-align: left;
          font-weight: 700;
          font-size: 19px;
          color: rgb(14, 12, 12);
          padding-bottom: 1.5rem;
        }
      }
    }
  }
}

// only mobile
@media (max-width: 768px) {
  .security {

    &__header {
      justify-content: flex-end;

      &__title {
        display: none;
      }
    }

    &__form__list {

      &__item--password {
        width: auto;
      }

      &__new-password {
        flex-direction: column;
      }

    }

  }
}
</style>